import { CommunicationBanner } from '@jane/bloom/components/communicationBanner';
import { BloomCarousel } from '@jane/bloom/components/communicationBanner/carouselBanner/bloomCarousel';
import { CategorySelector } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/categorySelector';
import { useTypedRouteLoaderData } from '@jane/bloom/hooks/useTypedRouteLoaderData';
import type { CarouselBanner } from '@jane/bloom/types/schemas/roots/carouselBanner';
import type { CommunicationBannerViewModel } from '@jane/bloom/viewModels/communicationBanner';

export type MenuHeaderBanners = {
  communicationBanner: CommunicationBannerViewModel;
  desktopCarouselBanner: CarouselBanner;
  mobileCarouselBanner: CarouselBanner;
  showCarousel: boolean;
  showImageBanner: boolean;
  storeName?: string;
};

type MenuHeaderProps = {
  // Only the featured page has banner data; other PLP pages render tabs only.
  banners?: MenuHeaderBanners;
};

// Keeps tabs + carousel + comms banner in one place so upcoming menu-theme
// params can reorder them (carousel above tabs; prominent search above carousel).
export function MenuHeader({ banners }: MenuHeaderProps) {
  const menuLayoutData = useTypedRouteLoaderData('routes/_menu');
  const displayCategories = menuLayoutData?.displayCategories;

  return (
    <>
      {displayCategories && (
        <CategorySelector displayCategories={displayCategories} />
      )}
      {banners && (
        <>
          {banners.showCarousel && banners.desktopCarouselBanner.length > 0 && (
            <div className="desktop-carousel-banner">
              <BloomCarousel
                items={banners.desktopCarouselBanner}
                storeName={banners.storeName}
              />
            </div>
          )}
          {banners.showCarousel && banners.mobileCarouselBanner.length > 0 && (
            <div className="mobile-carousel-banner">
              <BloomCarousel
                items={banners.mobileCarouselBanner}
                storeName={banners.storeName}
              />
            </div>
          )}
          <CommunicationBanner
            communicationBanner={banners.communicationBanner}
            showImageBanner={banners.showImageBanner}
          />
        </>
      )}
    </>
  );
}
